module.exports = __webpack_public_path__ + "static/media/logo120.d4500d90.png";